import type { Prototype } from "../prototype-types";

export const benjaminChaconPrototypes: Prototype[] = [
  {
    id: "bc-audiences",
    name: "Audiences",
    path: "/bc/audiences/overview",
    description:
      "Reimagined brand CRM: Overview, Segments & Lists, Contacts, and a disabled Automations nav item",
    owner: "Benjamin Chacon",
    createdAt: "2026-09-20",
    lastUpdated: "2026-10-02",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    project: "Audiences",
    thumbnail: "/images/thumbnails/bc-audiences.png",
    creationTool: "cursor",
  },
  {
    id: "bc-fd-adoption",
    name: "FD Adoption",
    path: "/bc/fd-adoption",
    description:
      "Explores contextual Brand Portal placements that drive adoption of Faire Direct.",
    owner: "Benjamin Chacon",
    createdAt: "2026-09-22",
    lastUpdated: "2026-09-22",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail: "/images/thumbnails/bc-fd-adoption.png",
  },
  {
    id: "bc-customer-profile",
    name: "Customer Profile",
    path: "/bc/customer-profile/contacts",
    description:
      "Teleties CRM customer details — Now, Next, and Future, with on-Faire and off-Faire lead states",
    owner: "Benjamin Chacon",
    createdAt: "2026-10-13",
    lastUpdated: "2026-11-03",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    project: "Faire CRM",
    thumbnail: "/images/thumbnails/bc-audiences.png",
    creationTool: "cursor",
  },
  {
    id: "bc-customers-table-brand-refinement",
    name: "Customers table (brand refinement)",
    path: "/bc/customers-table-brand-refinement",
    description: "Customers page Brand Refinement exploration",
    owner: "Benjamin Chacon",
    createdAt: "2026-10-20",
    lastUpdated: "2026-10-20",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    project: "Faire CRM",
    thumbnail: "/images/thumbnails/bc-audiences.png",
    creationTool: "cursor",
  },
];
